export default class Accordion {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Accordion;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-toggle-accordion', function(e) {
			e.preventDefault();
			self.toggleAccordion($(this));
		})
	}

	toggleAccordion($link) {
		const self = this;

		let $accordion = $link.parents('.accordion'),
			$section = $link.parents('.accordion-section'),
			$content = $link.next('.accordion-content');

		if ($content.is(':hidden')) {
			$accordion.find('.accordion-content').slideUp();
			$content.slideDown();

			$accordion.find('.accordion-section').removeClass('is-active');
			$section.addClass('is-active');
		} else {
			$content.slideUp();
			$section.removeClass('is-active');
		}

	}
}
